import React, { useMemo } from 'react';
import { ScheduleDateField } from 'shared/components/ui/schedule-date-field';
import { Toggle } from 'shared/components/ui/toggle';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';
import { getActiveSchedule } from 'shared/utils/get-active-schedule';

import * as Styled from './habit-form.style';

export type ScheduleEndDateInputProps = {
  enabled: boolean;
  onToggleEnabled: () => void;
  schedules: HabitSchedule[];
  onChange: (schedules: HabitSchedule[] | null) => void;
  weekStartsOn: WeekDays;
  dateFormat: DateFormatOptions;
  today: Timestamp;
};

export const ScheduleEndDateInput: React.FC<ScheduleEndDateInputProps> = ({
  enabled,
  onToggleEnabled,
  schedules,
  weekStartsOn,
  dateFormat,
  today,
  onChange,
}) => {
  const activeSchedule = useMemo(
    () => getActiveSchedule(schedules, today),
    [schedules, today],
  );

  const onChangeDate = (endDate: Date | null) => {
    const newSchedules = structuredClone(schedules);
    const scheduleToUpdate = getActiveSchedule(newSchedules, today);

    if (!scheduleToUpdate) {
      return;
    }

    scheduleToUpdate.endDate = endDate;

    onChange(newSchedules);
  };

  return (
    <Styled.ToggleRow>
      <Toggle value="endDate" checked={enabled} onChange={onToggleEnabled} />
      {enabled && (
        <Styled.ToggleRowContent>
          <ScheduleDateField
            value={activeSchedule?.endDate}
            onChange={onChangeDate}
            today={today}
            weekStartsOn={weekStartsOn}
            dateFormat={dateFormat}
            minDate={activeSchedule?.startDate}
          />
        </Styled.ToggleRowContent>
      )}
    </Styled.ToggleRow>
  );
};
